export default __webpack_public_path__ + "static/media/67.527ab53f.png";